import React from "react";
import { FiHeart, FiStar } from "react-icons/fi";
import { useHistory, useLocation } from "react-router-dom";

import {
  FooterContainer,
  FooterInner,
  FooterTop,
  FooterBrand,
  FooterTitle,
  FooterText,
  FooterPhone,
  FooterColumns,
  FooterColumn,
  FooterColumnTitle,
  FooterLink,
  FooterBottom,
  FooterCopyright,
  FooterSwitch,
  FooterSwitchButton,
  FooterSwitchIcon,
  FooterSwitchLabel,
} from "./styled";
import { scrollToSection } from "utils";
import { getLandpageVariantTheme } from "components/Landpage/theme-variants";

export default function Footer({ variant = "nursing" }) {
  const history = useHistory();
  const location = useLocation();
  const pageTheme = getLandpageVariantTheme(variant);
  const isAesthetics = variant === "aesthetics";
  const nursingHomePath = "/enfermagem";
  const aestheticsHomePath = "/estetica";
  const isNursingPath =
    location.pathname === "/" || location.pathname.startsWith(nursingHomePath);
  const isAestheticsPath = location.pathname.startsWith(aestheticsHomePath);

  const goToAestheticsSection = (sectionId) => {
    if (location.pathname !== aestheticsHomePath) {
      history.push(aestheticsHomePath);
      window.setTimeout(() => {
        scrollToSection(sectionId);
      }, 120);
      return;
    }

    scrollToSection(sectionId);
  };

  const navigateLanding = (path) => {
    if (location.pathname !== path) {
      history.push(path);
      return;
    }

    scrollToSection("banner");
  };

  const navLinks = isAesthetics
    ? [
        { title: "Início", action: () => goToAestheticsSection("banner") },
        { title: "Categorias", action: () => goToAestheticsSection("homecare") },
        { title: "Ranking", action: () => goToAestheticsSection("ranking") },
        { title: "Sobre", action: () => goToAestheticsSection("about") },
        { title: "Contato", action: () => goToAestheticsSection("footer") },
      ]
    : [
        { title: "Início", action: () => scrollToSection("banner") },
        { title: "Home Care", action: () => scrollToSection("homecare") },
        { title: "Serviços", action: () => scrollToSection("services") },
        { title: "Feedback", action: () => scrollToSection("feedback") },
        { title: "Contato", action: () => scrollToSection("footer") },
      ];

  const socialLinks = [
    { title: "E-mail", action: () => window.open("mailto:heloisaanddrade@gmail.com", "_blank") },
    { title: "WhatsApp", action: () => window.open("https://wa.me/61998333005", "_blank") },
    {
      title: "LinkedIn",
      action: () =>
        window.open("https://www.linkedin.com/in/helo%C3%ADsa-andrade-084a6820b/", "_blank"),
    },
    {
      title: "Instagram",
      action: () => window.open("https://www.instagram.com/draheloisaandrad_", "_blank"),
    },
  ];

  const landpages = [
    { key: "nursing", title: "Enfermagem", path: nursingHomePath, icon: FiHeart },
    { key: "aesthetics", title: "Estética", path: "/estetica", icon: FiStar },
  ];

  return (
    <FooterContainer id="footer" pageTheme={pageTheme} $aesthetic={isAesthetics}>
      <FooterInner $aesthetic={isAesthetics}>
        <FooterTop pageTheme={pageTheme} $aesthetic={isAesthetics}>
          <FooterBrand>
            <FooterTitle pageTheme={pageTheme} $aesthetic={isAesthetics}>
              {pageTheme.brand.footerTitle}
            </FooterTitle>
            <FooterText pageTheme={pageTheme} $aesthetic={isAesthetics}>
              {pageTheme.brand.footerLocation}
            </FooterText>
            <FooterPhone
              pageTheme={pageTheme}
              $aesthetic={isAesthetics}
              onClick={() => window.open("https://wa.me/61998333005", "_blank")}
            >
              +55 (61) 99833-3005
            </FooterPhone>
          </FooterBrand>

          <FooterColumns>
            <FooterColumn>
              <FooterColumnTitle pageTheme={pageTheme} $aesthetic={isAesthetics}>
                Contato
              </FooterColumnTitle>
              {socialLinks.map((item) => (
                <FooterLink
                  key={item.title}
                  pageTheme={pageTheme}
                  $aesthetic={isAesthetics}
                  onClick={item.action}
                >
                  {item.title}
                </FooterLink>
              ))}
            </FooterColumn>

            <FooterColumn>
              <FooterColumnTitle pageTheme={pageTheme} $aesthetic={isAesthetics}>
                Navegação
              </FooterColumnTitle>
              {navLinks.map((item) => (
                <FooterLink
                  key={item.title}
                  pageTheme={pageTheme}
                  $aesthetic={isAesthetics}
                  onClick={item.action}
                >
                  {item.title}
                </FooterLink>
              ))}
            </FooterColumn>
          </FooterColumns>
        </FooterTop>

        <FooterBottom $aesthetic={isAesthetics}>
          <FooterSwitch pageTheme={pageTheme} $aesthetic={isAesthetics}>
            {landpages.map((item) => {
              const Icon = item.icon;
              const isActive = item.key === "aesthetics" ? isAestheticsPath : isNursingPath;
              return (
                <FooterSwitchButton
                  key={item.key}
                  type="button"
                  $active={isActive}
                  pageTheme={pageTheme}
                  $aesthetic={isAesthetics}
                  onClick={() => navigateLanding(item.path)}
                >
                  <FooterSwitchIcon>
                    <Icon />
                  </FooterSwitchIcon>
                  <FooterSwitchLabel>{item.title}</FooterSwitchLabel>
                </FooterSwitchButton>
              );
            })}
          </FooterSwitch>

          <FooterCopyright
            pageTheme={pageTheme}
            $aesthetic={isAesthetics}
            onClick={() =>
              isAesthetics ? goToAestheticsSection("banner") : scrollToSection("banner")
            }
          >
            Dra. Heloisa Andrade®
          </FooterCopyright>
        </FooterBottom>
      </FooterInner>
    </FooterContainer>
  );
}
